import { makeStyles } from '@material-ui/core';

export const useDownloadAppStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(1, 2),
    background: theme.colors.Background_Secondary,
    position: 'absolute',
    bottom: 0,
    [theme.breakpoints.up('md')]: {
      borderRadius: '0 0  .5em .5em',
    },
  },
  link: {
    color: theme.colors.Text_1,
    '& > b': {
      color: theme.colors.PrimaryActive,
      cursor: 'pointer',
    },
  },
  imageIsotipe: {
    width: 40,
    height: 40,
    marginRight: theme.spacing(2),
  },
  texts: {
    textAlign: 'left',
  },
  icon: {
    marginLeft: 5,
    color: theme.colors.PrimaryActive,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      margin: theme.spacing(1, 0),
    },
  },
}));
